export default __webpack_public_path__ + "static/font-44b8eb1748838d2ac3165f02c6bd4f2c.woff2";